export default __webpack_public_path__ + "c39ff17277bf899547d9bc4f1c66a548.svg";